import SwapView from "./SwapView";

export default SwapView;
